import React from 'react';
import { Column } from 'react-virtualized';
import { message } from 'antd';

import EditableField from '../../../../../components/util/EditableField';
import {
  tableStyles,
  translateColumnHeader,
  simpleColumnHeader
} from '../../../tables/common';

const ContactsColumns = (onSave, extras) => {
  const editable = extras ? !(extras.editable === false) : true;
  return [
    <Column
      width={40}
      flexGrow={2}
      dataKey="name"
      key="Name"
      disableSort={true}
      headerRenderer={simpleColumnHeader}
      style={tableStyles.column}
      cellRenderer={({ cellData, rowData, rowIndex }) => {
        return (
          <EditableField
            innerStyle={{ marginBottom: 0 }}
            minWidthBefore={0}
            span={24}
            key={cellData}
            editable={editable}
            data={rowData}
            label="Name"
            hideElementBefore={true}
            hideIcon={true}
            value={cellData}
            onSave={async value =>
              await onSave({ value: value, field: 'name', index: rowIndex })
            }
            onSaveSuccess={() => message.success('Value Saved')}
            onSaveError={() =>
              message.error('Error saving value! Please try again.')
            }
          ></EditableField>
        );
      }}
    />,
    <Column
      width={80}
      flexGrow={4}
      dataKey="contact"
      key="contact"
      disableSort={true}
      headerRenderer={translateColumnHeader}
      style={tableStyles.column}
      cellRenderer={({ cellData, rowData, rowIndex }) => {
        return (
          <EditableField
            innerStyle={{ marginBottom: 0 }}
            minWidthBefore={0}
            span={24}
            key={cellData}
            editable={editable}
            data={rowData}
            label="Contact"
            hideElementBefore={true}
            hideIcon={true}
            value={cellData}
            onSave={async value =>
              await onSave({ value: value, field: 'contact', index: rowIndex })
            }
            onSaveSuccess={() => message.success('Value Saved')}
            onSaveError={() =>
              message.error('Error saving value! Please try again.')
            }
          ></EditableField>
        );
      }}
    />
  ];
};

export default ContactsColumns;
